import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useMemo, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import MobileHeader from "@/pages/checkout/arib-finance/component/MobileHeader";
import stl from "@/pages/checkout/finance-checkout/FreeFinanceFormPage.module.css";
import AribInfoComponent from "@/pages/checkout/arib-finance/component/AribInfoComponent";
import RequiredDocuments from "@/pages/checkout/arib-finance/component/RequiredDocuments";
import WorkInfoComponent from "@/pages/checkout/arib-finance/component/WorkInfoComponent";
import ValidateInfoFromSema from "@/pages/checkout/arib-finance/component/ValidateInfoFromSema";
import OTPForSema from "@/pages/checkout/arib-finance/component/OTPForSema";
import UserUploadInfo from "@/pages/checkout/arib-finance/component/UserUploadInfo";
import SemaNotEligible from "@/pages/checkout/arib-finance/component/SemaNotEligible";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useHelpers from "@hooks/useHelpers";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import SharedPopUp from "@componentsShared/SharedPopUp/SharedPopUp";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import PaymentComponent from "@/pages/checkout/arib-finance/component/PaymentComponent";
import PaymentProcessing from "@/pages/checkout/arib-finance/component/PaymentProcessing";
import { toast } from "sonner";
import { useSearchParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { trackEvents } from "@/common/events/events";
import useWebviewInputFieldFocusBehavior from "@hooks/useWebviewInputFieldFocusBehavior";
import useIsWebView from "@hooks/useIsWebview";
import useWebview from "@hooks/useWebview";
import FinanceDetailsBox from "@/pages/checkout/arib-finance/component/FinanceDetailsBox/FinanceDetailsBox";
import { api__getWarrantyList } from "@/apis/orders/orders";
import FinanceWarrantySection from "@/pages/checkout/warranty/FinanceWarrantySection";
var AribFinancePage = function AribFinancePage() {
  if (__IS_SSR__) return null;
  var lang = useLang();
  useWebviewInputFieldFocusBehavior(110);
  var _useAribFinance$state = useAribFinance().state,
    userInfo = _useAribFinance$state.userInfo,
    orderData = _useAribFinance$state.orderData,
    postData = _useAribFinance$state.postData,
    warrantyId = _useAribFinance$state.warrantyId;
  var _useAribFinance$actio = useAribFinance().actions,
    action__getCurrentTitle = _useAribFinance$actio.action__getCurrentTitle,
    action__clearLocalStorageData = _useAribFinance$actio.action__clearLocalStorageData,
    action__updateOrderInfo = _useAribFinance$actio.action__updateOrderInfo,
    action__setWarrantyId = _useAribFinance$actio.action__setWarrantyId;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var _useState = useState(true),
    loader = _useState[0],
    setLoader = _useState[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    getCurrentUrl = _useHelpers.getCurrentUrl,
    navigateToHard = _useHelpers.navigateToHard;
  var _useAribFinance$remot = useAribFinance().remote_actions,
    fetch__FinancePostData = _useAribFinance$remot.fetch__FinancePostData,
    fetch__deleteFinanceOrder = _useAribFinance$remot.fetch__deleteFinanceOrder,
    fetch__createAribOrder = _useAribFinance$remot.fetch__createAribOrder;
  var _useAribFinance = useAribFinance(),
    helpers = _useAribFinance.helpers;
  var _useAribFinance$query = useAribFinance().queryParams,
    post_id = _useAribFinance$query.post_id,
    financestep = _useAribFinance$query.financestep;
  var _useState2 = useState(financestep === 2 && !isLoggedIn),
    isOtpStep = _useState2[0],
    setIsOtpStep = _useState2[1];
  var _useState3 = useState(false),
    reachUpload = _useState3[0],
    setReachUpload = _useState3[1];
  var _useState4 = useState(false),
    ShowPopUp = _useState4[0],
    setShowPopUp = _useState4[1];
  var _useState5 = useState(null),
    checkoutOrder = _useState5[0],
    setCheckoutOrder = _useState5[1];
  var _useState6 = useState(warrantyId !== null && warrantyId !== void 0 ? warrantyId : null),
    selectedWarrantyId = _useState6[0],
    setSelectedWarrantyId = _useState6[1];
  var isWebView = useIsWebView();
  var webview = useWebview();
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {});
  }, [isWebView]);
  var hideTitleSection = useMemo(function () {
    return financestep === 5;
  }, [financestep]);
  var hideCarDetails = useMemo(function () {
    return financestep === 5;
  }, [financestep]);
  var hideHeaderMobile = useMemo(function () {
    return [5, 12].includes(financestep);
  }, [financestep]);
  useEffect(function () {
    var _JSON$parse;
    if (financestep !== 1) {
      if (!(userInfo !== null && userInfo !== void 0 && userInfo.first_name)) {
        navigateTo("/finance-apply-arib", {
          post_id: post_id,
          financestep: 1
        });
      }
    }
    fetch__FinancePostData();
    var dataInSession = sessionStorage.getItem("installment-calculator-".concat(post_id));
    var installmentPeriod = dataInSession ? (_JSON$parse = JSON.parse(dataInSession)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.period : null;
    api__getWarrantyList(_objectSpread({
      post_id: Number(post_id)
    }, installmentPeriod ? {
      installment_period: installmentPeriod
    } : {})).then(function (res) {
      setCheckoutOrder(function (prev) {
        return prev ? _objectSpread(_objectSpread({}, prev), res) : res;
      });
    })["catch"](function () {
      return null;
    });
  }, []);
  useEffect(function () {
    if (financestep < 5 && (orderData === null || orderData === void 0 ? void 0 : orderData.reachAribOtpStep) === true) {
      action__clearLocalStorageData();
      action__updateOrderInfo({
        "reachAribOtpStep": false
      });
      navigateToHard("/finance-apply-arib", {
        post_id: post_id,
        financestep: 1
      });
    }
  }, [orderData, financestep]);
  useEffect(function () {
    if ((postData === null || postData === void 0 ? void 0 : postData.have_finance) === false) {
      navigateToHard("/");
    }
  }, [postData]);
  var renderOTPStep = function renderOTPStep() {
    var verifyOtpCb = function verifyOtpCb(userData) {
      if (!isLoggedIn) {
        handleHasAccountEvent({
          hasAccount: userData.has_account,
          status: "Success",
          phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
          lang: lang,
          referral_location: "cash_order"
        });
      }
      setIsOtpStep(false);
      fetch__createAribOrder().then(function (res) {
        var _res$data;
        if (!res) {
          return navigateTo("/finance-apply-arib", {
            post_id: post_id,
            financestep: 13
          });
        }
        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.status) === 0) {
          navigateTo("/finance-apply-arib", {
            financestep: 12,
            post_id: post_id
          });
          return;
        }
        if ((res === null || res === void 0 ? void 0 : res['code']) === 200 && res !== null && res !== void 0 && res.data) {
          var _res$data2, _postData$g4Data, _postData$g4Data2, _postData$g4Data3, _postData$g4Data4, _postData$g4Data5, _postData$g4Data6, _res$data3;
          trackEvents("finance_initial_form_submit", {
            post_id: post_id,
            order_id: res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.order_id,
            post_price: postData === null || postData === void 0 ? void 0 : (_postData$g4Data = postData.g4Data) === null || _postData$g4Data === void 0 ? void 0 : _postData$g4Data.post_price,
            inventory_type: postData === null || postData === void 0 ? void 0 : (_postData$g4Data2 = postData.g4Data) === null || _postData$g4Data2 === void 0 ? void 0 : _postData$g4Data2.inventory_type_string,
            post_make: postData === null || postData === void 0 ? void 0 : (_postData$g4Data3 = postData.g4Data) === null || _postData$g4Data3 === void 0 ? void 0 : _postData$g4Data3.post_make,
            post_model: postData === null || postData === void 0 ? void 0 : (_postData$g4Data4 = postData.g4Data) === null || _postData$g4Data4 === void 0 ? void 0 : _postData$g4Data4.post_model,
            post_year: postData === null || postData === void 0 ? void 0 : (_postData$g4Data5 = postData.g4Data) === null || _postData$g4Data5 === void 0 ? void 0 : _postData$g4Data5.post_year,
            post_condition: postData === null || postData === void 0 ? void 0 : (_postData$g4Data6 = postData.g4Data) === null || _postData$g4Data6 === void 0 ? void 0 : _postData$g4Data6.post_condition,
            fees: res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.amount
            // finance_type: helper__getAribPaymentType(), // stopped for now since user have not entered salary yet
          });
          navigateTo("/finance-apply-arib", {
            post_id: post_id,
            financestep: 2
          });
        }
      })["catch"](function (e) {
        navigateTo("/finance-apply-arib", {
          post_id: post_id,
          financestep: 13
        });
      });
    };
    return /*#__PURE__*/React.createElement(OtpVerification, {
      FIX_ME__extra_params: {
        is_finance: true
      },
      source: "finance_order_verify",
      after_verify_callback: verifyOtpCb,
      scenario: "signup",
      phone_number: userInfo.mobile_number,
      onEditNumber: function onEditNumber() {
        navigateToHard("/finance-apply-arib", {
          post_id: post_id,
          financestep: 1
        });
      },
      design: {
        btnText: tShort("phone_number_verification", {
          "ns": "otp_screen"
        }),
        className: stl.otpWrapper,
        subClassName: stl.fontSize,
        label: tShort("enter_code_sent_to", {
          "ns": "otp_screen"
        }),
        otpBtn: stl.otpBtn,
        withborder: false
      }
    });
  };
  var renderStepContent = function renderStepContent() {
    var _ref, _checkoutOrder$financ, _checkoutOrder$financ2, _checkoutOrder$financ3, _checkoutOrder$financ4, _checkoutOrder$financ5, _checkoutOrder$financ6;
    //1: userIndo
    // 2: workInfo
    // 3:ValidateInfoFromSema
    // 4:OTPForSema
    // 5:UserUploadInfo
    // 6:not Eligible from sema
    // 7:nationalId Problem
    // 8: is_rejected_by_bank
    // 9: unable to send arib OTP
    // 10: payment step
    // 11: payment processing
    // 12: have active order
    // 13: Error in the api

    if (financestep === 12) {
      return /*#__PURE__*/React.createElement(SemaNotEligible, {
        customTitle: t("active_request", {
          ns: "web_checkout_finance"
        }),
        customText: t("cannot_submit_new_request_until", {
          ns: "web_checkout_finance"
        }),
        backToTrack: true
      });
    }
    if (financestep === 11) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentProcessing, null));
    }
    if (helpers.helper__paymentEnabled() && financestep === 10) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentComponent, null));
    }
    if (financestep === 9) {
      return /*#__PURE__*/React.createElement(SemaNotEligible, {
        customTitle: t("error_failed_send_verification_code", {
          ns: "web_checkout_finance"
        }),
        customText: t("error_re_unable_send_otp_moment", {
          ns: "web_checkout_finance"
        }),
        backToForm: true
      });
    }
    if (financestep === 8) {
      return /*#__PURE__*/React.createElement(SemaNotEligible, {
        customTitle: t("error_apologize_2", {
          ns: "web_checkout_finance"
        }),
        customText: t("information_meet_bank_financing_criteria", {
          ns: "web_checkout_finance"
        }),
        backToForm: true
      });
    }
    if (financestep === 7) {
      return /*#__PURE__*/React.createElement(SemaNotEligible, {
        customTitle: tShort("arib/sema_otp_could_not_sent_title", {
          ns: "web_checkout_finance"
        }),
        customText: tShort("arib/sema_otp_could_not_sent_description", {
          ns: "web_checkout_finance"
        }),
        contTopUpload: true
      });
    }
    if (financestep === 6) {
      return /*#__PURE__*/React.createElement(SemaNotEligible, {
        customTitle: t("error_apologize_2", {
          ns: "web_checkout_finance"
        }),
        customText: t("unfortunately_re_eligible_financing", {
          ns: "web_checkout_finance"
        })
      });
    }
    if (financestep === 4) {
      return /*#__PURE__*/React.createElement(OTPForSema, null);
    }
    if (financestep === 3) {
      return /*#__PURE__*/React.createElement(ValidateInfoFromSema, null);
    }
    if (financestep === 13) {
      var errorMessage = searchParams.get("error_message") || t("error_unexpected_error_occurred_try_again", {
        ns: "web_checkout_finance"
      });
      var errorTitle = searchParams.get("error_title") || t("error_something_went_wrong", {
        ns: "web_checkout_finance"
      });
      toast.error(errorMessage, {
        position: "bottom-center",
        duration: 5000,
        style: {
          zIndex: 9999999
        }
      });
      return /*#__PURE__*/React.createElement(SemaNotEligible, {
        customTitle: errorTitle,
        customText: errorMessage,
        backToForm: true
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "mx-auto !w-[80%] max-w-[1152px] max-lg:!w-[90%] after:content-[''] after:fixed after:bottom-0 after:left-0 after:w-full after:h-full after:z-[-1] after:bg-[#ffffff] sm:after:bg-[#fafcff] !mt-0 md:!mt-8"
    }, !isMobile && financestep != 5 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: ["whtBtn", stl.backBtn].join(" "),
      onClick: function onClick() {
        return setShowPopUp(true);
      }
    }, t("cancel", {
      ns: "web_checkout_finance"
    })), /*#__PURE__*/React.createElement("strong", {
      className: "text-3xl font-bold leading-10 text-[#3C56D4] mt-[24px] block"
    }, action__getCurrentTitle())), /*#__PURE__*/React.createElement("div", {
      className: twMerge("flex flex-col-reverse sm:flex-row items-start justify-between pb-10 gap-[22px] mt-0 md:!mt-8", hideTitleSection && "md:block md:mt-8", financestep === 5 && "mt-[50px]")
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full relative p-0 border-none sm:p-[32px_24px] sm:rounded-xl sm:border sm:border-solid sm:border-[#EBF0F7] sm:bg-white sm:min-w-[660px] sm:max-w-[660px] md:mx-auto"
    }, financestep === 1 && /*#__PURE__*/React.createElement(AribInfoComponent, {
      setIsOtpStep: setIsOtpStep,
      setMobileNUmberForEvent: "99",
      warrantyId: (_ref = selectedWarrantyId !== null && selectedWarrantyId !== void 0 ? selectedWarrantyId : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$financ = checkoutOrder.finance_warrantyV2) === null || _checkoutOrder$financ === void 0 ? void 0 : (_checkoutOrder$financ2 = _checkoutOrder$financ.items) === null || _checkoutOrder$financ2 === void 0 ? void 0 : (_checkoutOrder$financ3 = _checkoutOrder$financ2.find(function (i) {
        return i.selected;
      })) === null || _checkoutOrder$financ3 === void 0 ? void 0 : _checkoutOrder$financ3.id) !== null && _ref !== void 0 ? _ref : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$financ4 = checkoutOrder.finance_warrantyV2) === null || _checkoutOrder$financ4 === void 0 ? void 0 : (_checkoutOrder$financ5 = _checkoutOrder$financ4.items) === null || _checkoutOrder$financ5 === void 0 ? void 0 : (_checkoutOrder$financ6 = _checkoutOrder$financ5[0]) === null || _checkoutOrder$financ6 === void 0 ? void 0 : _checkoutOrder$financ6.id
    }), financestep === 2 && /*#__PURE__*/React.createElement(WorkInfoComponent, {
      updateLoader: false,
      g4Data: postData === null || postData === void 0 ? void 0 : postData.g4Data
    }), financestep === 5 && /*#__PURE__*/React.createElement(UserUploadInfo, {
      InformParentPopUpIsOpen: setReachUpload
    })), /*#__PURE__*/React.createElement("div", {
      className: "w-full sm:min-w-[444px] sm:max-w-[444px]"
    }, !hideCarDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FinanceDetailsBox, {
      showEditIcon: +financestep == 1 && !isOtpStep,
      checkoutOrder: checkoutOrder,
      setCheckoutOrder: setCheckoutOrder,
      selectedWarrantyId: selectedWarrantyId
    }), /*#__PURE__*/React.createElement("div", {
      className: "mt-5"
    }, /*#__PURE__*/React.createElement(FinanceWarrantySection, {
      canChangeWarranty: +financestep === 1 && !isOtpStep,
      checkoutOrder: checkoutOrder,
      orderType: "finance",
      referralLocation: "checkout",
      onWarrantyChange: (/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
          var _JSON$parse2, _checkoutOrder$financ7;
          var dataInSession, sessionPeriod, currentPeriod, params, updated;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                setSelectedWarrantyId(id);
                action__setWarrantyId(id !== null && id !== void 0 ? id : null);
                dataInSession = sessionStorage.getItem("installment-calculator-".concat(post_id));
                sessionPeriod = dataInSession ? (_JSON$parse2 = JSON.parse(dataInSession)) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.period : null;
                currentPeriod = sessionPeriod !== null && sessionPeriod !== void 0 ? sessionPeriod : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$financ7 = checkoutOrder.finance_calculator_data) === null || _checkoutOrder$financ7 === void 0 ? void 0 : _checkoutOrder$financ7.installment_period;
                params = {
                  post_id: Number(post_id),
                  warranty_id: id
                };
                if (currentPeriod) {
                  params.installment_period = currentPeriod;
                }
                _context.n = 1;
                return api__getWarrantyList(params)["catch"](function () {
                  return null;
                });
              case 1:
                updated = _context.v;
                if (updated) setCheckoutOrder(function (prev) {
                  return prev ? _objectSpread(_objectSpread({}, prev), updated) : updated;
                });
              case 2:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }())
    }))), financestep === 1 && /*#__PURE__*/React.createElement(RequiredDocuments, {
      className: "m-hide",
      blueStyle: false
    }))));
  };
  return /*#__PURE__*/React.createElement(Layout, {
    hideHeaderOnmobile: true,
    custommobileHeader: !reachUpload && isMobile && !hideHeaderMobile && /*#__PURE__*/React.createElement(MobileHeader, {
      isOtpStep: isOtpStep,
      financestep: financestep,
      loader: loader,
      updateShowPopUp: setShowPopUp,
      hideTitleSection: hideTitleSection
    }),
    disableLoader: true,
    hideFooterWithoutAuthMsg: true,
    authenticationMsg: true,
    hideAppBanner: true,
    linksForSearch: true,
    mainClass: "AribFinancePage",
    headHideLinks: true,
    hideOrangeHeadBtn: true
  }, isOtpStep && renderOTPStep(), !isOtpStep && renderStepContent(), ShowPopUp && /*#__PURE__*/React.createElement(SharedPopUp, {
    show: ShowPopUp,
    onClose: function onClose() {
      return setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.freeFinanceCancelOreder
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.freeFinanceCancelIcon
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-center"
  }, t("sure_cancel_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, t("information_saved_need_refill_data", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "blueBtn",
    onClick: function onClick() {
      setShowPopUp(false);
    }
  }, t("continue_application", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    className: "whtBtn",
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!(orderData !== null && orderData !== void 0 && orderData.order_uuid)) {
              _context2.n = 1;
              break;
            }
            setShowPopUp(false);
            setLoader(true);
            _context2.n = 1;
            return fetch__deleteFinanceOrder(orderData === null || orderData === void 0 ? void 0 : orderData.order_uuid);
          case 1:
            navigateTo("/cardetail/".concat(post_id));
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }))
  }, t("cancel_submitting_application", {
    ns: "web_tracking"
  })))));
};
export default AribFinancePage;